import { Pipe, PipeTransform } from '@angular/core';

export type FormatType = 'cnpj' | 'currency' | 'removeMask' | 'cpf';

export interface FormatOptions {
  locale?: string;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

@Pipe({
  name: 'format',
  pure: true,
})
export class FormatPipe implements PipeTransform {
  transform(value: any, type: FormatType, options?: FormatOptions): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    switch (type) {
      case 'cpf':
        return this.formatToCPF(value);
      case 'cnpj':
        return this.formatToCNPJ(value);
      case 'currency':
        return this.formatToCurrency(value, options);

      case 'removeMask':
        return this.removeMask(value);

      default:
        console.warn(`FormatPipe: Tipo "${type}" não reconhecido`);
        return String(value);
    }
  }

  private removeMask(value: string): string {
    if (!value) return '';
    return String(value).replace(/\D/g, '');
  }

  private formatToCNPJ(value: string | number): string {
    if (!value) return '';

    const cleanedValue = this.removeMask(String(value));

    if (cleanedValue.length !== 14) {
      console.warn('FormatPipe: CNPJ deve ter 14 dígitos');
    }

    return cleanedValue
      .slice(0, 14)
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  private formatToCurrency(
    value: string | number,
    options?: FormatOptions
  ): string {
    const numericValue =
      typeof value === 'string'
        ? parseFloat(this.removeMask(value).replace(',', '.'))
        : value;

    if (isNaN(numericValue)) {
      console.warn('FormatPipe: Valor inválido para currency');
      return '';
    }

    const locale = options?.locale || 'pt-BR';
    const currency = options?.currency || 'BRL';
    const minimumFractionDigits = options?.minimumFractionDigits ?? 2;
    const maximumFractionDigits = options?.maximumFractionDigits ?? 2;

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(numericValue);
  }

  private formatToCPF(value: string | number): string {
    if (!value) return '';

    const cleanedValue = this.removeMask(String(value));

    if (cleanedValue.length !== 11) {
      console.warn('FormatPipe: CPF deve ter 11 dígitos');
    }

    return cleanedValue.slice(0, 11).replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1-$2');
  }
}
